import React from 'react';

const Help = () => {
  return <>Help Page</>;
};

export default Help;
